// extracted by mini-css-extract-plugin
export default {"container":"truck_container__2ff-u","body":"truck_body__KAYIO","textName":"truck_textName__IVW0P","textValue":"truck_textValue__CGmdp","buttonAction":"truck_buttonAction__ga2lT"};